import React from 'react';
import { CardSubWrapper, CardWrapper } from 'admin/components/wrappers';
import CustomDataGrid from 'app/components/CustomDataGrid/Index';
import { TableSkeletonLoader } from 'app/components/TableSkeletonLoader';
import DynamicTitleCell from 'app/components/CustomDataGrid/Cells/DynamicTitleCell';
import { PendingRiderApproval, GeneralLookup, PendingRidersList, ApproveRiderRequest } from 'services/openapi';
import styled from 'styled-components';
import { GridCellProps } from '@progress/kendo-react-grid';
import AdminCustomButton from 'app/components/AdminCustomButton';
import { CustomDeletePopup } from 'app/components/CustomDeletePopup';
import { set } from 'date-fns';

type Props = {
    pendingRidersData?: PendingRidersList;
    setPageSkip: React.Dispatch<React.SetStateAction<number | undefined>>;
    pageSkip: number | undefined;
    fetchPendingRiders: (
        searchName?: string,
        pageNumber?: number,
        pageSize?: number,
    ) => void;
    approvePendingRider: (requestBody?: ApproveRiderRequest, callback?: () => void) => void
    debounceSearchTerm: string;
    loading: boolean;
    pageSize: number;
    pageSizeSelected: GeneralLookup;
};

const ApproveRiderTable = ({
    pendingRidersData,
    setPageSkip,
    pageSkip,
    fetchPendingRiders,
    approvePendingRider,
    debounceSearchTerm,
    loading,
    pageSize,
    pageSizeSelected,
}: Props) => {
    const [showPopup, setShowPopup] = React.useState<{ isOpen: boolean; riderId: string }>({ isOpen: false, riderId: "" });
    const handleApproveClick = (riderId: string) => {
        setShowPopup({ isOpen: true, riderId });

    };
    const handleApproveConfirmRider = (riderId: string) => {
        const requestBody = { riderSeasonMapId: riderId, approve: true } as ApproveRiderRequest;
        approvePendingRider(requestBody, () => {
            fetchPendingRiders(
                debounceSearchTerm,
                pageSkip,
                pageSize,
            );
        });
    }

    const handlePageChange = (event: any) => {
        setPageSkip(event.page.skip);
        fetchPendingRiders(
            debounceSearchTerm,
            event.page.skip,
            pageSize,
        );
    };

    const ActionCell = ({ dataItem, e }: { dataItem: PendingRiderApproval, e: GridCellProps }) => (
        <td className={e.className} style={{ ...e.style, textAlign: 'center' }}>
            <AdminCustomButton
                buttonType="primary"
                isActive={false}
                onClick={() => handleApproveClick(dataItem.riderSeasonMapId || '')}
            >
                Approve
            </AdminCustomButton>
        </td >
    );

    const ridersColumns = [
        {
            field: 'action',
            title: 'Action',
            cell: (e: any) => <ActionCell dataItem={e.dataItem} e={e} />,
            width: '110',
            locked: true,
            className: 'team-name-style',
            headerClassName: 'team-header-style',

        },
        {
            field: 'riderName',
            title: 'Rider Name',
            cell: (e: any) => (
                <DynamicTitleCell
                    e={e}
                    onClick={() => { }}
                    title={e.dataItem.riderName}
                    isCenter
                />
            ),
            width: '200',
            locked: true,
            className: 'team-name-style',
            headerClassName: 'team-header-style',
        },
        {
            field: 'riderEmail',
            title: 'Email',
            cell: (e: any) => (
                <DynamicTitleCell
                    e={e}
                    onClick={() => { }}
                    title={e.dataItem.riderEmail}
                    isCenter
                />
            ),
            width: '220',
        },
        {
            field: 'teamName',
            title: 'Team Name',
            cell: (e: any) => (
                <DynamicTitleCell
                    e={e}
                    onClick={() => { }}
                    title={e.dataItem.teamName}
                    isCenter
                />
            ),
            width: '200',
        },
        {
            field: 'category',
            title: 'Category',
            cell: (e: any) => (
                <DynamicTitleCell
                    e={e}
                    onClick={() => { }}
                    title={e.dataItem.category?.name}
                    isCenter
                />
            ),
            width: '150',
        },
        {
            field: 'division',
            title: 'Division',
            cell: (e: any) => (
                <DynamicTitleCell
                    e={e}
                    onClick={() => { }}
                    title={e.dataItem.division?.name}
                    isCenter
                />
            ),
            width: '150',
        },
        {
            field: 'classOne',
            title: 'Class One',
            cell: (e: any) => (
                <DynamicTitleCell
                    e={e}
                    onClick={() => { }}
                    title={e.dataItem.classOne?.name}
                    isCenter
                />
            ),
            width: '150',
        },
        {
            field: 'classTwo',
            title: 'Class Two',
            cell: (e: any) => (
                <DynamicTitleCell
                    e={e}
                    onClick={() => { }}
                    title={e.dataItem.classTwo?.name}
                    isCenter
                />
            ),
            width: '150',
        },
    ];
    console.log(pendingRidersData?.riders, 'pendingRidersData?.riders')
    return (
        <>
            {loading ? (
                <TableSkeletonLoader rowContent={8} width={100} headingWidth={80} />
            ) : (
                <>
                    <CardWrapper style={{ paddingTop: '15px' }}>
                        <CardSubWrapper className="d-flex"></CardSubWrapper>
                        <GridWrapper>
                            <CustomDataGrid
                                showPagination={(pendingRidersData?.pageDetails?.count ?? 0) > Number(pageSizeSelected.id)}
                                data={pendingRidersData?.riders ?? []}
                                columns={ridersColumns}
                                pageSize={pageSize}
                                totalCount={pendingRidersData?.pageDetails?.count}
                                onPageChange={handlePageChange}
                                skip={pageSkip}
                            />
                        </GridWrapper>
                    </CardWrapper>
                </>
            )}
            <CustomDeletePopup
                deleteIcon={true}
                popupSubLabel="Are you sure you want to approve this rider?"
                className="body-scroll-lock height-full PendingRiderApprovalPopup"
                popupLabel="Approve Rider"
                setVisible={(visible: boolean) => {
                    setShowPopup(prev => ({ ...prev, isOpen: visible }));
                }}
                visible={showPopup.isOpen}
                align="centre"
                btnLabel1="Cancel"
                btnLabel2="Confirm"
                handlebtn2Click={() => handleApproveConfirmRider(showPopup.riderId)}
                handlebtn1Click={() => {
                    setShowPopup({ isOpen: false, riderId: "" });
                }}
            />
        </>
    );
};

export default ApproveRiderTable;

const GridWrapper = styled.div`
  .k-grid-container {
    height: calc(100vh - 255px);
  }
  .k-table-thead {
    .k-link {
      cursor: default;
    }
  }
  .btn {
    padding: 6px 12px;
    font-size: 12px;
    border-radius: 4px;
    border: none;
    cursor: pointer;
    transition: all 0.3s ease;

    &:hover:not(:disabled) {
      opacity: 0.9;
    }

    &:disabled {
      opacity: 0.6;
      cursor: not-allowed;
    }
  }

  .btn-primary {
    background-color: #007bff;
    color: white;

    &:hover:not(:disabled) {
      background-color: #0056b3;
    }
  }
 .k-grid-header tr th:nth-child(1) .k-cell-inner .k-link{
    justify-content: center;
 }
`;